import { useState, useEffect } from "react";
import { TESTIMONIALS } from "@/lib/siteData";
import { ChevronLeft, ChevronRight } from "lucide-react";
import EmblemMotif from "@/components/site/EmblemMotif";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % TESTIMONIALS.length);
    }, 7000);
    return () => clearInterval(t);
  }, []);

  const current = TESTIMONIALS[idx];

  return (
    <section
      id="testimonials"
      className="py-24 md:py-32"
      data-testid="testimonials-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="eyebrow" data-testid="testimonials-overline">In Their Words</p>
        <EmblemMotif size="md" className="mt-8" />
        <blockquote
          key={idx}
          className="mt-8 font-headings italic text-2xl md:text-4xl leading-snug text-primary fade-up"
          data-testid="testimonials-quote"
        >
          "{current.quote}"
        </blockquote>
        <div className="mt-10">
          <p
            className="font-ui text-sm uppercase tracking-[0.2em] text-foreground"
            data-testid="testimonials-name"
          >
            {current.name}
          </p>
          <p className="mt-1 font-body text-sm text-foreground/60" data-testid="testimonials-role">
            {current.role}
          </p>
        </div>

        <div className="mt-10 flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
            className="w-10 h-10 rounded-sm border border-border hover:border-primary hover:text-primary text-foreground/70 flex items-center justify-center"
            aria-label="Previous testimonial"
            data-testid="testimonials-prev"
          >
            <ChevronLeft size={16} />
          </button>
          {TESTIMONIALS.map((_, i) => (
            <button
              type="button"
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Show testimonial ${i + 1}`}
              data-testid={`testimonials-dot-${i}`}
              className={`h-[2px] transition-all ${
                i === idx ? "w-10 bg-primary" : "w-5 bg-border"
              }`}
            />
          ))}
          <button
            type="button"
            onClick={() => setIdx((i) => (i + 1) % TESTIMONIALS.length)}
            className="w-10 h-10 rounded-sm border border-border hover:border-primary hover:text-primary text-foreground/70 flex items-center justify-center"
            aria-label="Next testimonial"
            data-testid="testimonials-next"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
